import React from 'react';
import { Plus } from 'lucide-react';

export type AssociationCountCellProps = {
  count: number;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  triggerDataAttr?: string;
  onAdd?: () => void;
  addLabel?: string;
};

export function AssociationCountCell({
  count,
  onClick,
  triggerDataAttr,
  onAdd,
  addLabel = 'Add association',
}: AssociationCountCellProps): React.ReactElement {
  const isDisabled = count <= 0;
  const cellClassName = isDisabled
    ? 'inline-flex items-center justify-center min-w-8 px-2 py-1 text-xs font-semibold text-gray-400 bg-gray-100 border border-gray-200 rounded-md cursor-default'
    : 'inline-flex items-center justify-center min-w-8 px-2 py-1 text-xs font-semibold text-blue-700 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100';

  return (
    <div className="inline-flex items-center gap-0" data-association-anchor>
      <button
        type="button"
        disabled={isDisabled}
        {...(triggerDataAttr ? { [triggerDataAttr]: true } : {})}
        className={cellClassName}
        onClick={onClick}
      >
        {isDisabled ? 0 : count}
      </button>
      {typeof onAdd === 'function' ? (
        <button
          type="button"
          onClick={onAdd}
          className="inline-flex items-center justify-center rounded-sm p-0.5 text-blue-600 hover:text-blue-700"
          aria-label={addLabel}
          title={addLabel}
        >
          <Plus className="h-3 w-3" />
        </button>
      ) : null}
    </div>
  );
}

export default AssociationCountCell;
